import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('GET_PERSONS'),
  ...asyncTypes('UPDATE_PERSON'),
  ...asyncTypes('CREATE_PERSON'),
  ...asyncTypes('GET_PERSON'),
  ...asyncTypes('ARCHIVE_PERSON')
};

export default TYPES;
